const config = {
  blockPaymentWhenDesignIsDeprecated: false,
};

module.exports = config;
